import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import { Variables } from "@repo/skapa";

export const Line = styled.div`
  height: ${Variables.thicknessThin};
  border-bottom: ${Variables.thicknessThin} solid ${LightMode.colourNeutral3};
`;
